const u = up.util;
const e = up.element;
const HTML_FORM_METHODS = ['GET', 'POST'];
up.Request.FormRenderer = class FormRenderer {
    constructor(request) {
        this._request = request;
    }
    buildAndSubmit() {
        this.params = this._request.params.withoutBinaryEntries();
        let action = this._request.url;
        let { method } = this._request;
        const paramsFromQuery = up.Params.fromURL(action);
        this.params.addAll(paramsFromQuery);
        action = up.Params.stripURL(action);
        if (!u.contains(HTML_FORM_METHODS, method)) {
            method = up.protocol.wrapMethod(method, this.params);
        }
        this._form = e.affix(document.body, 'form.up-request-loader', { method, action });
        let contentType = this._request.contentType;
        if (contentType) {
            this._form.setAttribute('enctype', contentType);
        }
        let csrfParam, csrfToken;
        if ((csrfParam = this._request.csrfParam()) && (csrfToken = this._request.csrfToken())) {
            this.params.add(csrfParam, csrfToken);
        }
        u.each(this.params.toArray(), this._addField.bind(this));
        up.browser.submitForm(this._form);
    }
    _addField(attrs) {
        e.affix(this._form, 'input[type=hidden]', attrs);
    }
};
